
function HomeScreen (): JSX.Element {
    return (
        <></>
    );
}

export default HomeScreen;
